import React from 'react';
import Container from 'react-bootstrap/Container';
import Slider from '../components/Slider/slider';
import Courses from '../components/Courses';
import Partners from '../components/Partners';
import News from '../components/News';
import Vagas from '../components/Vagas';
import Mentor from '../components/Mentoria';

const Home = () => (
   <>
      <Slider />      
      <Container>
         <Vagas />
         <Mentor />
         <Courses />
         <News />
         <Partners />
      </Container>         
   </>
);
export default Home;